<template>
	<div class="content">
		<h3>数码批量查询下载</h3>
		<div class="item">
			<el-form ref="form" inline  :model="form" label-width="80px">				
				<el-form-item label=" " style="width:100%">
                    <el-radio-group v-model="form.radio" style="display: inline-flex;">
                        <el-radio :label="1">单件查询</el-radio>
                        <el-radio :label="2">多件查询</el-radio>
                    </el-radio-group>
				</el-form-item>
                <div v-if="form.radio==1">
                    <el-form-item label="数码">
                        <el-input v-model="form.factoryName"></el-input>
                    </el-form-item>
                </div>
                <div v-if="form.radio==2">
                    <el-form-item label="数码文件">
                        <el-upload
                        class="upload-demo"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        multiple
                        :limit="3"
                        :on-exceed="handleExceed"
                        :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">导入txt格式文件</div>
                        </el-upload>
                    </el-form-item>
                </div>
			</el-form>
			<div class="btn">
				<el-button type="primary"  @click="SelFactory">查 询</el-button>
				<el-button type="warning">重 置</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			tableData: [],
			form:{
                radio:2,
            },
			rules: {
        		factoryName:[
          			{ required: true, message: '请输入一个工厂名称', trigger: 'change' }
        		],
			},
			pageNum:0,
		}
	},
	methods: {
		close(){
			this.$refs['form'].resetFields()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
        },
        handleCurrentChange(){

        }
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:10px 80px;
}
.el-input,.el-select{
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/PularCodeTrace.vue